/**
 * Обкладинка анонсу уроку — сторінка, з якої ми РОБИМО СКРІНШОТ.
 *
 * Owner 2026-09-12: «обкладинка з анонсом уроку не відповідає дизайну апки —
 * ні шрифти, ні рівність, ні оформлення. Має бути один в один апка, як
 * ніби зробили скріншот».
 *
 * Тому картинку більше не малюємо ffmpeg'ом: тут рендериться САМ застосунок
 * (ті самі компоненти, шрифти й відступи, що на екрані уроку), а скрипт
 * `scripts/lesson_card_shot.py` знімає з нього скріншот у headless Chrome.
 * Дані приходять параметрами, тому сторінці не потрібні ні авторизація, ні API.
 *
 * /card/lesson?title=...&cat=...&dur=...&speaker=...&poster=/poster.jpg
 */
import { useEffect } from "react";

import { Icon } from "@/components/Icon";

export function LessonCardPage() {
  // Фіксуємо еталонну ширину телефона (390pt) і базовий кегль 16px. Без цього
  // headless-браузер рендерить у своїй ширині: `max-w-md` розтягується до
  // 448px, а корінь через `clamp(…100vw…)` дає 17.6px — і скрін виходить не
  // такий, як на телефоні (текст обрізало по правому краю).
  useEffect(() => {
    const html = document.documentElement;
    const prevFont = html.style.fontSize;
    const prevWidth = document.body.style.width;
    html.style.fontSize = "16px";
    document.body.style.width = "390px";
    document.body.style.margin = "0";
    document.body.dataset.lessonCard = "1";
    // Висоту картки повідомляємо у <title>: скріншотер читає її першим
    // проходом (--dump-dom) і робить вікно РІВНО під контент. Обрізати за
    // кольором не вийшло — фонове «сяйво» плавно змінюється по всій сторінці.
    const report = () => {
      const el = document.querySelector("[data-card-root]");
      if (!el) return;
      const bottom = el.getBoundingClientRect().bottom + window.scrollY;
      document.title = `cardh:${Math.ceil(bottom + 20)}`;
    };
    const t = window.setTimeout(report, 400);
    window.addEventListener("load", report);
    return () => {
      window.clearTimeout(t);
      window.removeEventListener("load", report);
      html.style.fontSize = prevFont;
      document.body.style.width = prevWidth;
    };
  }, []);

  const p = new URLSearchParams(window.location.search);
  const title = p.get("title") || "Назва уроку";
  const cat = p.get("cat") || "База знань";
  const dur = p.get("dur") || "";
  const poster = p.get("poster") || "";

  return (
    <>
      {/* Обкладинка закінчується карткою спікера: прибираємо футер із
          посиланням на оферту і розтяг на весь екран, щоб скрін не тягнув за
          собою пів сторінки порожнечі. */}
      <style>{`
        body[data-lesson-card] .mt-24.pb-10 { display: none !important; }
        body[data-lesson-card] .min-h-screen { min-height: 0 !important; }
      `}</style>
      {/* Owner 2026-09-12: «скрін починається на назві категорії і
          закінчується, коли закінчується урок». Тому ні лого, ні «Назад»,
          ні «Меню», ні секції «Спікер» тут немає. */}
      <div data-card-root className="pt-2">
      <div className="mb-3 flex items-center gap-2 font-mono text-[0.65625rem] uppercase tracking-[0.08em] text-ink-dim">
        <span className="h-1.5 w-1.5 rounded-full bg-primary" />
        {cat}
        {dur && (
          <>
            <span>·</span>
            <span className="inline-flex items-center gap-1">
              <Icon name="clock" size={12} />
              {dur}
            </span>
          </>
        )}
      </div>

      <h1
        className="mb-4 font-display font-bold text-ink"
        style={{ fontSize: "1.625rem", lineHeight: 1.1, letterSpacing: "-0.02em" }}
      >
        {title}
      </h1>

      <div className="overflow-hidden rounded-ios-card bg-black shadow-card-soft">
        {poster ? <img src={poster} alt="" className="block w-full" /> : null}
      </div>
      </div>
    </>
  );
}
